// import messages from './messages';
const SubscribeSchema = (config, intl) => {
  return {
    title: 'Subscribe',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'image', 'href'],
      },
    ],
    properties: {
      title: {
        type: 'string',
        title: 'title',
        // widget: 'richtext',
      },
      image: {
        title: 'image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        selectedItemAttrs: ['image_field', 'image_scales'],
      },
      href: {
        title: 'Url',
        widget: 'object_browser',
        mode: 'link',
      },
    },
    required: [],
  };
};

export default SubscribeSchema;
